<template>
  <div id="container" class="effect aside-float aside-bright mainnav-out slide">
    <common-header></common-header>

    <div class="boxed">
      <div id="content-container">
        <div id="page-content" style="padding-top: 80px">
          <div class="col-lg-6 col-lg-offset-3">
            <div class="panel">
              <form class="form-horizontal" @submit.prevent="handleUserUpdate">
                <div class="panel-heading">
                  <h3 class="panel-title">
                    资料修改<span class="text-danger" v-if="isDefaultPW"
                      >（请修改密码）</span
                    >
                  </h3>
                </div>
                <hr class="m-t-0" />
                <div class="panel-body">
                  <div class="row">
                    <div class="col-lg-6 col-md-6">
                      <div class="form-group">
                        <label class="col-md-4 control-label">用户名</label>
                        <div class="col-md-8">
                          <input
                            type="text"
                            class="form-control"
                            :class="{ error: $v.user.name.$error }"
                            v-model="user.name"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-md-4 control-label">电话号码</label>
                        <div class="col-md-8">
                          <input
                            type=""
                            class="form-control"
                            :class="{ error: $v.user.phone_number.$error }"
                            v-model="user.phone_number"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-md-4 control-label">新密码</label>
                        <div class="col-md-8">
                          <input
                            type="password"
                            class="form-control"
                            v-model="new_password"
                            placeholder="修改密码填写"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-md-4 control-label">确认新密码</label>
                        <div class="col-md-8">
                          <input
                            type="password"
                            class="form-control"
                            placeholder="修改密码填写"
                            v-model="repeat_password"
                          />
                        </div>
                      </div>
                      <div class="form-group" v-if="phoneChanged">
                        <label class="col-md-4 control-label">验证码</label>
                        <div class="col-md-8 captcha">
                          <input
                            type="text"
                            class="form-control"
                            v-model="captcha"
                          />
                          <div
                            class="input-group-addon"
                            @click="sendCaptcha"
                            v-if="!computedTime"
                          >
                            获取验证码
                          </div>
                          <div class="input-group-addon" v-show="computedTime">
                            已发送({{ computedTime }}s)
                          </div>
                        </div>
                      </div>
                      <!-- <div class="form-group">
                        <label class="col-md-4 control-label">旧密码</label>
                        <div class="col-md-8">
                          <input
                            placeholder="修改密码填写"
                            type="password"
                            class="form-control"
                            v-model="user.old_password"
                          />
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
                <div class="panel-footer">
                  <div class="row">
                    <div class="col-lg-6 col-md-6">
                      <div class="col-md-8 col-md-offset-4">
                        <button class="btn btn-success btn-labeled">
                          保存
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer id="footer">
      <p class="text-center">&#0169; {{ new Date().getFullYear() }} 天锐峡谷</p>
    </footer>
  </div>
</template>

<script>
import CommonHeader from '@/components/Header'
import { userUpdateProfile, mobileCode } from '@/service/getData'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { getStore } from '@/config/mUtils'
import { mapMutations } from 'vuex'

const rightPhoneNumber = (value) => /^1\d{10}$/gi.test(value)

export default {
  components: {
    CommonHeader,
  },
  validations: {
    user: {
      name: {
        required,
        maxLength: maxLength(20),
      },
      phone_number: {
        required,
        rightPhoneNumber,
      },
    },
  },
  data() {
    return {
      captcha: '',
      computedTime: 0,
      originalUser: getStore('userInfo'),
      user: getStore('userInfo'),
      new_password: '',
      repeat_password: '',
      isDefaultPW: false,
    }
  },
  computed: {
    phoneChanged() {
      return this.user.phone_number != this.originalUser.phone_number
    },
  },
  created() {
    if (this.originalUser.default_pswd) {
      this.isDefaultPW = true
    }
  },
  methods: {
    ...mapMutations(['LOGOUT']),
    async sendCaptcha() {
      if (/^1\d{10}$/gi.test(this.user.phone_number)) {
        let res = await mobileCode(this.user.phone_number)
        if (res.status == 0) {
          this.computedTime = 60
          this.timer = setInterval(() => {
            this.computedTime--
            if (this.computedTime == 0) {
              clearInterval(this.timer)
            }
          }, 1000)
        }
      } else {
        this.$dialog.alert('手机号错误')
      }
    },
    async handleUserUpdate() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      if (this.new_password || this.isDefaultPW) {
        if (this.new_password.length < 6 || this.new_password.length > 15) {
          this.$dialog.alert('密码长度为 6 到 15 个字符')
          return
        }
        if (this.repeat_password != this.new_password) {
          this.$dialog.alert('两次输入的密码不一样')
          return
        }

        // if (!this.captcha) {
        //   this.$dialog.alert('修改密码，验证码不能为空')
        //   return
        // }
      }

      let res = await userUpdateProfile({
        name: this.user.name,
        phone_number: this.user.phone_number,
        code: parseInt(this.captcha),
        new_password: this.new_password,
        repeat_password: this.repeat_password,
      })
      if (res.status != 0) return false
      if (this.new_password) {
        this.$dialog.alert('密码已修改，请重新登录')
        this.LOGOUT()
        this.$router.push('/login')
      } else {
        this.$dialog.alert('修改成功')
      }
    },
  },
}
</script>

<style scoped>
.captcha {
  display: flex;
}

.input-group-addon {
  cursor: pointer;
  width: 180px;
  margin-left: 10px;
  line-height: 31px;
  padding-top: 0;
  padding-bottom: 0;
  border-left: 1px solid #dedede;
}
</style>
